import React from 'react';
import { Drawer, Box, IconButton, Typography } from '@mui/material';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowLeft01FreeIcons, ArrowRight01FreeIcons, Invoice01Icon, LogoutSquare01Icon, PieChartIcon, Settings01FreeIcons } from '@hugeicons/core-free-icons';
import { useNavigate } from 'react-router-dom';

const drawerWidthExpanded = 220;
const drawerWidthCollapsed = 70;

const Sidebar = ({ expanded, onToggle, activeKey, setActiveKey }) => {
    const navigate = useNavigate();

    const menuItems = [
        { key: 'Dashboard', icon: PieChartIcon, label: 'Dashboard', path: '/dashboard' },
        { key: 'Bills', icon: Invoice01Icon, label: 'Bills', path: '/bills' },
        { key: 'Categories', icon: Invoice01Icon, label: 'Categories', path: '/categories' },
        { key: 'Settings', icon: Settings01FreeIcons, label: 'Settings', path: '/settings' },
    ];

    const handleClick = (key, path) => {
        setActiveKey(key);
        navigate(path);
    };

    const handleMouseEnter = () => {
        if (!expanded) onToggle(true);
    };
    // const handleMouseLeave = () => {
    //     if (expanded) onToggle(false);
    // };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh');
        navigate('/login');
    };

    return (
        <Drawer
            variant="permanent"
            PaperProps={{
                sx: {
                    width: expanded ? drawerWidthExpanded : drawerWidthCollapsed,
                    transition: 'width 0.2s',
                    overflowX: 'hidden',
                    bgcolor: '#fff',
                    borderRadius: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                },
            }}
            onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        >
            <Box>
                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: expanded ? 'space-between' : 'center',
                        px: 2,
                        height: 64,
                    }}
                >
                    {expanded ? (
                        <img src="/logo.svg" alt="Remembr" style={{ height: 26, display: 'block' }} />
                    ) : (
                        <img src="/logo-icon.svg" alt="Remembr" style={{ width: 30, height: 30, display: 'block' }} />
                    )}

                    <IconButton onClick={() => onToggle(!expanded)} size="small">
                        {expanded ? (
                            <HugeiconsIcon icon={ArrowLeft01FreeIcons} color="#0056ff" size={20} />
                        ) : (
                            <HugeiconsIcon icon={ArrowRight01FreeIcons} color="#0056ff" size={20} />
                        )}
                    </IconButton>
                </Box>

                {/* Menu Items */}
                <Box sx={{ mt: 3, p: 1 }}>
                    {menuItems.map((item) => (
                        <Box
                            key={item.key}
                            onClick={() => handleClick(item.key, item.path)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: expanded ? 'flex-start' : 'center',
                                bgcolor: activeKey === item.key ? '#E7F0FD' : 'transparent',
                                borderRadius: 2,
                                px: expanded ? 3 : 1,
                                py: 2,
                                cursor: 'pointer',
                                mb: 2,
                            }}
                        >
                            <HugeiconsIcon icon={item.icon} size={20} />
                            {expanded && (
                                <Typography sx={{ ml: 2, fontWeight: 500, fontSize: 14 }}>
                                    {item.label}
                                </Typography>
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box
                onClick={handleLogout}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: expanded ? 'flex-start' : 'center',
                    px: expanded ? 3 : 1,
                    py: 2,
                    mb: 2,
                    cursor: 'pointer',
                    color: 'red',
                }}
            >
                <HugeiconsIcon icon={LogoutSquare01Icon} size={20} color="red" />
                {expanded && (
                    <Typography sx={{ ml: 2, fontWeight: 500, fontSize: 14, color: 'red' }}>
                        Sign Out
                    </Typography>
                )}
            </Box>
        </Drawer>
    );
};

export default Sidebar;